<template>
  <div class="container">
    <div class="copyright-block">
      Указанная стоимость товаров и условия их приобретения действительны по состоянию на текущую дату.
      На информационном ресурсе применяются <a href="/recommendation_rules">рекомендательные технологии</a>
      (информационные технологии предоставления информации на основе сбора,
      систематизации и анализа сведений, относящихся к предпочтениям пользователей сети «Интернет»,
      находящихся на территории Российской Федерации).
      <recaptcha-text v-if="isGoogleRecaptchaOn" />
      <br><br>
      &copy;&nbsp;{{ currentYear }}, FUNDAY. Все права защищены. Юридический адрес: г. Москва, ул. Профсоюзная, д. 61А,
      <a href="mailto:helpme@fundayshop.com">helpme@fundayshop.com</a> (для направления юридически значимых сообщений)
    </div>
  </div>
</template>

<script>
import features from '@common/constants/features';

import recaptchaText from '@/components/common/recaptchaText';

export default {
  name: 'copyright-block',
  components: {
    recaptchaText,
  },
  computed: {
    isGoogleRecaptchaOn() {
      return this.$isFeatureEnabled(features.GOOGLE_RECAPTCHA_ON);
    },
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="scss">
.copyright-block {
  margin-top: 24px;
  padding-bottom: 16px;
  color: $gray;
  font-size: 12px;
  line-height: 16px;

  &::before {
    display: block;
    width: 100%;
    height: 1px;
    margin-bottom: 16px;
    background-color: $gray-lu;
    content: "";
  }

  & > a {
    color: $black;
  }
}

@include breakpoint("tablet") {
  .copyright-block {
    margin-top: 0;
    padding-bottom: 32px;
  }
}
@include breakpoint("desktop") {
  div.copyright-block {
    margin-top: 56px;
    padding-bottom: 56px;
  }
}
</style>
